import React from "react";
import { Query } from "react-apollo";
import { Tunnel } from "react-tunnels";
import { css } from "glamor";
import * as R from "ramda";

import Button from "@arachnys/styleguide/Button";
import { withApolloState } from "../../util";
import { GET_PROCESS_HISTORY } from "./queries";
import TopBar from "./topbar";
import ProcessHistoryComponent from "./ProcessHistoryComponent";

const styles = {
    downloadContainer: css({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }),
};

const DownloadButton = process => {
    const reportUrl = R.pathOr(
        null,
        ["process", "processHistory", "reportUrl"],
        process
    );
    return (
        <div className={styles.downloadContainer}>
            <a href={reportUrl}>
                <Button.Ghost darkbg disabled={!reportUrl}>
                    Download
                </Button.Ghost>
            </a>
        </div>
    );
};

const ProcessHistory = props => {
    const processRelayId = btoa("Process:" + props.match.params.id);
    const entityId = btoa("Entity:" + props.match.params.entityUlid);

    return (
        <Query
            query={GET_PROCESS_HISTORY}
            variables={{ id: processRelayId, entityUlid: entityId }}
            fetchPolicy="cache-and-network"
        >
            {withApolloState(({ data }) => (
                <>
                    <Tunnel id="bluebar-left-content">
                        <TopBar
                            entity={data.entity}
                            schema={data.EntitySchema}
                            process={data.process}
                        />
                    </Tunnel>
                    <Tunnel id="bluebar-right-content">
                        <DownloadButton process={data.process} />
                    </Tunnel>
                    <ProcessHistoryComponent
                        data={data}
                        processRelayId={processRelayId}
                    />
                </>
            ))}
        </Query>
    );
};

export default ProcessHistory;
